import { Component } from 'react'
import { Redirect } from 'react-router'

export default class ErrorBound extends Component {
  state = {
    hasError: false,
  }

  // componentDidCatch(error, errorInfo) {
  //   // this.setState({ hasError: true });
  // }

  render() {
    if (this.state.hasError) {
      return <Redirect to={'/500'} />
    }

    return this.props.children
  }
}
